import {
  useCallback, useEffect, useLayoutEffect, useState
} from 'react'

function getBrowserVisibilityProp() {
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    return 'visibilitychange'
  }
  if (typeof document.msHidden !== 'undefined') {
    return 'msvisibilitychange'
  }
  if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitvisibilitychange'
  }
  return ''
}

function getBrowserDocumentHiddenProp() {
  if (typeof document.hidden !== 'undefined') {
    return 'hidden'
  }
  if (typeof document.msHidden !== 'undefined') {
    return 'msHidden'
  }
  if (typeof document.webkitHidden !== 'undefined') {
    return 'webkitHidden'
  }
  return ''
}


const visibilityChange = getBrowserVisibilityProp()
const hiddenProp = getBrowserDocumentHiddenProp()

function getIsDocumentHidden() {
  return document[hiddenProp]
}

export function usePageVisibility() {
  const [isVisible, setIsVisible] = useState(!getIsDocumentHidden())
  const onVisibilityChange = () => setIsVisible(!getIsDocumentHidden())

  useEffect(() => {
    document.addEventListener(visibilityChange, onVisibilityChange, false)

    return () => {
      document.removeEventListener(visibilityChange, onVisibilityChange)
    }
  }, [])

  return isVisible
}

function log(name, ...elements) {
  // console.log(`[useResumingObserver] >> ${name} >>`, ...elements)
}

const MIN_TIME_OUTSIDE = 2 * 1000

function useReturningObserver() {
  const [active, setActive] = useState(false)
  const [leaveTimestamp, setLeaveTimestamp] = useState(null)
  const [enterTimestamp, setEnterTimestamp] = useState(null)

  const pageIsVisible = usePageVisibility()

  // NOTE: Must use useLayoutEffect to detect leaving at the correct time (bug with mobile Firefox)
  // Bug: with "useEffect" instead of "useLayoutEffect", the "useEffect" hook does not get triggered when the user leaves but when the user comes back.
  // (this messes up the leaveTimestamp, thus breaking the minimum delay required for "hasReturned" to be triggered)
  useLayoutEffect(() => {
    log('useLayoutEffect[pageIsVisible]', { pageIsVisible })
    if (!pageIsVisible) {
      setLeaveTimestamp(Date.now())
    } else {
      setEnterTimestamp(Date.now())
    }
  }, [pageIsVisible])

  const observe = useCallback(() => {
    setEnterTimestamp(null)
    setLeaveTimestamp(null)
    setActive(true)
  }, [])
  const unobserve = useCallback(() => { setActive(false) }, [])

  const leftSince = (active && enterTimestamp && leaveTimestamp) ? enterTimestamp - leaveTimestamp : 0
  const hasReturned = MIN_TIME_OUTSIDE < leftSince
  log('run', { active, leftSince, hasReturned })

  return {
    observe,
    unobserve,
    hasReturned,
    observing: active,
    enterTimestamp,
    leaveTimestamp
  }
}

export default useReturningObserver
